/* eslint-disable max-len */

import { AbstractTranslation } from './AbstractTranslation';

class Translation extends AbstractTranslation {
  signin = {
    kana: 'サインイン',
    en: 'Singin',
  };
  signout = {
    en: 'Signout',
    kana: 'サインアウト',
  };
  close = {
    en: 'Close',
    kana: 'とじる',
  };
  copy = {
    en: 'Copy',
    kana: 'コピー',
  };
  cancel = {
    en: 'Cancel',
    kana: 'キャンセル',
  };
  mail_signin = {
    kana: 'メールアドレスでサインイン',
    en: 'Sing in with Email',
  };
  create_account = {
    kana: 'アカウントさくせい',
    en: 'Create Account',
  };
  top_desc = {
    en: 'BLOCKVROCK is a free programming language where you can create your own VR / AR world.',
    kana: 'BLOCKVROCKは、ビジュアルプログラミングげんごの「blockly」をつかって、PC/スマートフォン/タブレット/VRヘッドセットのどれでもかんたんにじぶんだけのVRくうかんやARアプリをつくることができます。サインインするだけで、むりょうですぐにつかいはじめられます！',
  };
  welcome = {
    en: "Welcome to BLOCKVROCK! 🎉🎉🎉 First, click the 'Create new' button to create a project.",
    kana: 'BLOCKVROCKへようこそ！ 🎉🎉🎉 はじめは「あたらしくつくる」ボタンをクリックしてプロジェクトを つくりましょう。',
  };
  user = {
    en: 'User',
    kana: 'ユーザー',
  };
  user_list = {
    en: 'User List',
    kana: 'ユーザーいちらん',
  };
  user_edit = {
    en: 'User Edit',
    kana: 'ユーザーじょうほうをかきかえる',
  };
  qa = {
    en: 'Q & A',
    kana: 'おといあわせ',
  };
  project_list = {
    en: 'Project List',
    kana: 'さくひんリスト',
  };
  list_currentPageSuffix = {
    en: 'Page',
    kana: 'ページめ',
  };
  list_maxPageSuffix = {
    en: '',
    kana: 'ページ',
  };
  list_projectCountTitle = {
    en: 'All Projects',
    kana: 'ぜんぶで',
  };
  list_filter = {
    en: 'Filter',
    kana: 'けんさく',
  };
  project_default_title = {
    en: 'Unnamed Project',
    kana: '名前のないプロジェクト',
  };
  list_addNewTitle = {
    en: 'Create New',
    kana: 'あたらしくつくる',
  };
  list_copy = {
    en: 'Copy',
    kana: 'コピー',
  };
  list_del = {
    en: 'Delete',
    kana: 'さくじょ',
  };
  list_confirm_copy = {
    en: ' Are you sure you want to copy',
    kana: 'このプロジェクトをコピーします。よろしいですか？',
  };
  list_confirm_delete = {
    en: ' Are you sure you want to delete ',
    kana: 'このプロジェクトをさくじょします。よろしいですか？',
  };
  list_created = {
    en: 'is created',
    kana: 'をさくせいしました',
  };
  save_success = {
    en: 'Saved successfully',
    kana: 'ほぞんしました',
  };
  copied = {
    en: 'Copied',
    kane: 'コピーしました',
  };
  liked_can_not_delete = {
    en: 'Linked Project is can not delete',
    kana: 'リンクされているのでさくじょできませんでした',
  };
  file = {
    en: 'File',
    kana: 'ファイル',
  };
  template_list = {
    en: 'Template List',
    kana: 'テンプレートいちらん',
  };
  ar_marker_list = {
    en: 'AR marker list',
    kana: 'ARマーカーリスト',
  };
  open_tab = {
    en: 'Open Other Tab',
    kana: 'べつのタブでひらく',
  };
  flickr360 = {
    en: 'flickr (VR Background)',
    kana: 'はいけいしゃしんをみつける',
  };
  filckr_title = {
    en: 'Get VR background image from Flickr',
    kana: 'FlickrからVRはいけいがぞうをしゅとく',
  };
  file_manager = {
    en: 'User Files [3D Model,Image,Movie,Sound](My Assets) ',
    kana: '3Dモデル、がぞう、どうが、おんがくのファイル(マイアセット)',
  };
  qr_code = {
    en: 'QR Code',
    kana: 'QRコード',
  };
  open_another_tab = {
    en: 'Open New Tab Page',
    kana: 'あたらしいページでひらく',
  };
  project_export = {
    en: 'Project Export',
    kana: 'プロジェクトエクスポート',
  };
  project_import = {
    en: 'Project Import',
    kana: 'プロジェクトインポート',
  };
  recovery = {
    en: 'Recovery',
    kana: 'まちがえ をやりなおす',
  };
  ar_marker_title = {
    en: 'AR Marker List',
    kana: 'ARマーカーいちらん',
  };
  contact_us_title = {
    en: 'Contact Us',
    kana: 'おといあわせ',
  };
  unsubscribe = {
    en: 'Unsubscribe',
    kana: 'ユーザーさくじょ',
  };
  confirm_unscribe_user = {
    en: 'Are you sure you want to unsubscribe?',
    kana: 'ユーザーをさくじょしてよろしいですか？',
  };
  done_unscribe_user = {
    en: 'done unsubscribed',
    kana: 'ユーザーをさくじょしました',
  };
  title_unsubscribed = {
    en: 'Will cancel the membership. Once you unsubscribe, you will not be able to use the works you have created so far.',
    kana: 'ユーザーをさくじょします。いちど さくじょするとこれまでにつくった さくひんは りようできなくなります。',
  };
  user_id = {
    en: 'User Id',
    kana: 'ユーザーID',
  };
  user_name = {
    en: 'User Name',
    kana: 'なまえ',
  };

  user_edit_name: {
    en: 'Name';
    kana: '氏名';
  };
  user_edit_title = {
    en: 'User Profile edit',
    kana: 'ユーザじょうほうへんしゅう',
  };
  user_edit_update = {
    en: 'Uodate',
    kana: 'こうしん',
  };
  user_edit_exit = {
    en: 'Unsubscribe',
    kana: 'たいかい',
  };
  change_pass = {
    en: 'Change Password',
    kana: 'パスワードへんこう',
  };
  current_pass = {
    en: 'Please enter your current password',
    kana: 'げんざいのパスワードをにゅうりょくしてください',
  };
  new_pass = {
    en: 'New Password',
    kana: 'あたらしいパスワード',
  };
  new_pass_label = {
    en: 'Please enter a new password',
    kana: 'あたらしいパスワードをにゅうりょくしてください',
  };
  confirm_pass_label = {
    en: 'Please enter new again to confirm',
    kana: 'かくにんのためあたらしいをもういちどにゅうりょくしてください',
  };
  confirm_pass = {
    en: 'Confirm password',
    kana: 'かくにんパスワード',
  };

  email = {
    en: 'Email',
    kana: 'メールアドレス',
  };
  password = {
    en: 'Password',
    kana: 'パスワード',
  };
  skechfab_title = {
    en: 'Skechfab import',
    kana: '3Dモデルサイト Skechfab',
  };
  sf_contents1 = {
    en: 'You can add many high quality 3D models uploaded to SkechFab to BLOCKVROCK.',
    kana: 'SkechFabにアップロードされた たくさん の　こうひんしつ な３DモデルをBLOCKVROCKに ついか することができます。',
  };
  sf_contents2 = {
    en: 'To work with Skechfab, you need to create a Skechfab account and log in.',
    kana: 'Skechfabと れんけい するためには、Skechfabのアカウントを さくせい してログインする ひつよう があります。',
  };
  sf_contents3 = {
    en: 'At the bottom of this screen',
    kana: 'この がめん のいちばんしたの',
  };
  sf_contents4 = {
    en: 'Create a Skechfab account with the button.',
    kana: 'ボタンでSkechfabのアカウント作成を実施します。',
  };
  sf_contents5 = {
    en: 'If you already have a Skechfab account, please log in at the next screen',
    kana: 'すでにSkechfabアカウントをお持ちの場合は、次の画面でログインしてください',
  };
  sf_contents6 = {
    en: "If you don't have a Skechfab account, click Create an account.",
    kana: 'Skechfabアカウントがない ばあい は「Create an account」をクリックします。',
  };
  sf_contents7 = {
    en: `Enter your email address at the top of the 'Sign up' 
      screen where you clicked 'Create an account', or create an account with
      the social account link button at the bottom of the screen.`,
    kana: `「Create an account」をクリックしたさきの「Signup」がめん
      の うえにメールアドレスをうちこむか、または がめんのした 
      にあるソーシャルアカウントれんけいボタンでアカウントをつくります。`,
  };
  sf_contents8 = {
    en: "After logging in, click the 'ACCEPT' button to approve the link.",
    kana: 'ログインができたら「ACCEPT」ボタンで連携を承認します。',
  };
  sf_connect_btn = {
    en: 'Connect to Skechfab',
    kana: 'Skechfabと れんけい',
  };
  sf_author = {
    en: 'Author',
    kana: 'さくしゃ',
  };
  sf_title = {
    en: 'Title',
    kana: 'タイトル',
  };
  sf_get_data_error = {
    en: 'ScketchFab get data',
    kana: 'ScketchFabデータをとるとき',
  };
  sf_model_viewer_attention = {
    en: 'A plane detection AR block has been added. Please execute the plane detection AR independently without setting the scene start.',
    kana: 'へいめんけんちARモデルブロックを ついか しました。へいめんけんち ARはシーンスタートを おかずに じっこう してください',
  };
  sf_find = {
    en: 'Find',
    kana: 'けんさく',
  };
  sf_comment = {
    en: '',
    kana: 'アルファベットでけんさく(れい: RED)',
  };
  sf_3dmodel = {
    en: '3D Model',
    kana: '3Dモデル',
  };
  sf_model_viewer = {
    en: 'Plane Detect AR',
    kana: '平面検知AR',
  };
  notice = {
    en: 'Notice',
    kana: 'おしらせ',
  };
  tutorial = {
    en: 'Tutorial',
    kana: 'チュートリアル',
  };
  tutorial_title = {
    en: 'BLOCKVROCK Tutorial',
    kana: 'BLOCKVROCK チュートリアル',
  };
  back = {
    en: 'Back',
    kana: 'もどる',
  };
  back_to_block = {
    en: 'Back To Block',
    kana: 'ブロックがめんへもどる',
  };
  upload = {
    en: 'Uplaod',
    kana: 'アップロード',
  };
  uploaded = {
    en: 'is uploaded',
    kana: 'をアップロードしました',
  };
  file_deleted = {
    en: 'is deleted',
    kana: 'をさくじょしました',
  };
  file_page_preset = {
    en: 'Preset ',
    kana: 'プリセット',
  };
  file_page_user = {
    en: 'My Assets',
    kana: 'マイアセット',
  };
  file_event = {
    en: 'Files for Event',
    kana: 'イベント',
  };

  accept_extentions = {
    en: 'Corresponding extension',
    kana: 'たいおう する ファイル しゅるい',
  };
  file_path = {
    en: 'File Path',
    kana: 'ファイルパス',
  };
  select_upload = {
    en: 'Select Upload File',
    kane: 'アップロードするファイルをえらぶ',
  };
  preset_upload = {
    en: 'preset file upload',
    kana: 'プリセットファイルアップロード',
  };
  filter_sound = {
    en: 'Sound',
    kana: 'おと',
  };
  filter_movie = {
    en: 'Movie',
    kana: 'どうが',
  };
  filter_image = {
    en: 'Image',
    kana: 'がぞう',
  };
  filter_model = {
    en: 'Model',
    kana: 'モデル',
  };
  filter_all = {
    en: 'All',
    kana: 'すべて',
  };
  event_code_confirm = {
    en: 'Please enter the event code.',
    kana: 'イベントコードをにゅうりょくしてください',
  };
  no_files = {
    en: 'File does not exist. 🔍',
    kana: 'ファイルがそんざいしません. 🔍',
  };
  sketch_fab_list = {
    en: 'Sketchfab Model List',
    kana: 'スケッチファブモデルリスト',
  };
  filter_text_placeholder = {
    en: 'Search by file name',
    kana: 'ファイルめいでけんさく',
  };
  sf_request_download = {
    en: 'Request Download',
    kana: 'ダウンロードをリクエスト',
  };
  template_title = {
    en: 'Choose a template to get started',
    kana: 'テンプレートをえらんではじめよう',
  };
  template_preset = {
    en: 'Preset ',
    kana: 'ひょうじゅん',
  };
  template_event = {
    en: 'Template for Event',
    kana: 'イベント',
  };

  template_event_input = {
    en: 'Please enter the event code.',
    kana: 'イベントコードをにゅうりょくしてください',
  };
  file_preview_title = {
    en: 'Preview',
    kana: 'プレビュー',
  };
  take_thumbnail = {
    en: 'Take thumbnail',
    kana: 'しゃしんをとる',
  };
  error_take_thumbnail = {
    en: 'Error at take thumbnail',
    kana: 'サムネイルのしゅとくにしっぱいしました',
  };
  reverse_position_success = {
    en: 'Restoration of the saved position is complete.',
    kana: 'ほぞんした いち をせっていしなおしました',
  };
  save_position_complete = {
    en: 'Save position is complete. Please reflect the saved position on the block page.',
    kana: 'いち をほぞんしました。ブロックがめんで せっていしなおしてください',
  };
  reverse_position = {
    en: 'Restoration of the saved position',
    kana: 'ほぞんしたブロックのいちをもどす',
  };
  save = {
    en: 'Save',
    kana: 'ほぞん',
  };
  no_name_title = {
    en: 'No name project',
    kana: 'なまえのないプロジェクト',
  };
  save_failed = {
    en: 'Save failed',
    kana: 'ほぞんにしっぱいしました',
  };
  console_show = {
    en: 'Show Console',
    kana: 'コンソールをひょうじする',
  };
  size = {
    en: 'Size',
    kana: 'サイズ',
  };
  backup_recovery_title = {
    en: 'Projects saved during this login (last 100)',
    kana: 'ログインしているあいだにほぞんしたプロジェクト（さいきんの100けん）',
  };
  not_review = {
    en: 'Do not redisplay',
    kana: 'さいひょうじしない',
  };
  save_dialog_title_input_label = {
    en: 'Title',
    kana: 'タイトル',
  };
  msg_del = {
    en: 'Are you sure you want to delete?',
    kana: 'さくじょします',
  };
  recovery_msg = {
    en: 'Recover with the following project. Recovering will overwrite the current project. <br>Is it OK?',
    kana: 'このプロジェクトにもどします。もどすといまのプロジェクトはうわがきされます。<br>よろしいですか？',
  };
  title = {
    en: 'Title',
    kana: 'タイトル',
  };
  class_room = {
    en: 'Class Room',
    kana: 'クラスルーム',
  };
  invite_class_room = {
    en: 'Invite to class room',
    kana: 'クラスルームへのしょうたい',
  };
  class_presentation = {
    en: 'Class Presentation',
    kana: 'クラス はっぴょうかい',
  };
  not_support_device = {
    en: "Sorry. This browser doesn't seem to support this feature",
    kana: 'このブラウザはこのきのうがつかえないようです',
  };
  invite_url = {
    en: 'Invitation URL',
    kana: 'しょうたいリンク',
  };
  desc_invite_to_class = {
    en: '2. Invite members ',
    kana: '2. メンバーをしょうたい',
  };
  member_list = {
    en: '1. Create Member List',
    kana: '1. メンバーリストをさくせい',
  };
  added_member = {
    en: 'Member added',
    kana: 'メンバーをついかしました',
  };
  saved_class_member = {
    en: 'Class Member Saved ',
    kana: 'メンバーをこうしんしました',
  };
  confirm_delete_class_member = {
    en: 'Are you sure you want to delete',
    kana: 'をさくじょします。よろしいですか？',
  };
  deleted_class_member = {
    en: 'Class Member Deleted ',
    kana: 'メンバーをさくじょしました',
  };

  name = {
    en: 'Name',
    kana: 'なまえ',
  };
  delete = {
    en: 'Delete',
    kana: 'さくじょ',
  };
  select = {
    en: 'Select',
    kana: 'せんたく',
  };
  class_member_project_list = {
    en: 'Class Member Project List',
    kana: 'クラスメンバー作品リスト',
  };
  class_room_program = {
    en: 'Member Program ',
    kana: 'メンバープログラム',
  };
  className = {
    en: 'Class Name',
    kana: 'クラスめい',
  };
  class_room_description = {
    en: 'Log in to Classroom. Choose the name assigned to you.',
    kana: 'クラスルームにログインします。じぶんにわりあてられたなまえをせんたくしてください。',
  };
  class_presentation_desc = {
    en: 'The latest projects for each class member are listed.',
    kana: 'クラスメンバーそれぞれのさいしんのプロジェクトがリストアップされます。',
  };
  plan_change = {
    en: 'Plan Rate Change',
    kana: 'りょうきんプランをかえる',
  };
  plan_change_cancel = {
    en: 'Cancel Plan Rate Change',
    kana: 'りょうきんプランのかえるをやめる',
  };
  plan_change_cancel_done = {
    en: 'Plan Rate Change Cancel Done',
    kana: 'りょうきんプランのかえるをやめました',
  };
  plan_change_done = {
    en: 'Plan Rate Change Done',
    kana: 'りょうきんプランのへんこうが、かんりょうしました',
  };
  my_assets = {
    en: 'My Assets',
    kana: 'マイアセット',
  };
  recommend_asset = {
    en: 'Recommendation Assets',
    kana: 'おすすめアセット',
  };
  confirm_open_doc = {
    en: 'Open the document page in a new tab. Are you sure?',
    kana: 'あたらしいタブでドキュメントページをひらきます。よろしいですか？',
  };
  document = {
    en: 'Document',
    kana: 'ドキュメント',
  };
  word_to_canvas_ar = {
    en: 'Word to Canvas AR',
    kana: 'もじ から え をかいてARをつくる',
  };
  word_to_image = {
    en: 'Word to Image',
    kana: 'ことば で え をかく',
  };

  to_canvas_model_done = {
    en: 'Canvas model created',
    kana: 'キャンバスに え をかきおえました',
  };
  change_plan_title = {
    en: 'Change Plan',
    kane: 'りょうきんプランのへんこう',
  };
}
export const translation = new Translation();
